// ./Archives.js
import React, { useState } from "react";
import EditTodoForm from "./EditTodoForm"; // adapte le chemin si nécessair
import { useEtatGlobal } from "../EtatGlobal.js";
import { authFetch } from '../../HttpClient';
// import { CiFilter } from "react-icons/ci";
import PreparationPopup from "./Preparation";
import DiligencePopup from "./Diligences";
import EvenementPopup from "./Evenement";
import VerificationPopup from "./Verification";
import DextPopup from "./Dext";
import MissionPopup from "../Portefeuille/Mission";

import { FaUserEdit } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import { HiMiniArchiveBox } from "react-icons/hi2";
import { ChevronDown } from "lucide-react";

import { dialog } from "../../components/ui/Dialog";
function Archives({ todos, fetchTodos, setTodos }) {
  const { utilisateur, patchTodoLocal, removeTodoLocal } = useEtatGlobal();
  const [showEditForm, setShowEditForm] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [editTodo, setEditTodo] = useState(null);

  const [collapsedUsers, setCollapsedUsers] = useState({});

  // `todos` est une structure imbriquée (un bloc par utilisateur) : on garde
  // le même regroupement que la vue active, avec uniquement les archivés
  const archivedByUser = todos
    .map((block) => ({
      ...block,
      todos: (block.todos || []).filter((t) => t.status === "Archiver"),
    }))
    .filter((block) => block.todos.length > 0);

  const toggleUserCollapse = (userKey) => {
    setCollapsedUsers((prev) => ({
      ...prev,
      [userKey]: !prev[userKey],
    }));
  };

  const [formData, setFormData] = useState({
    title: "",
    status: "",
    nomClient: "",
    clientId: "",
    nature: "",
    dueDate: "",
    priority: "",
    commentaire: "",
    userIds: [],
  });
  const [selectedClient, setSelectedClient] = useState(null);

  //   const [filterRows, setFilterRows] = useState([
  //     { column: "status", selectedValues: [] },
  //   ]);
  //   const [showFilterOverlay, setShowFilterOverlay] = useState(false);
  //   const overlayRef = useRef(null);

  //   useEffect(() => {
  //     const handleClickOutside = (e) => {
  //       if (overlayRef.current && !overlayRef.current.contains(e.target)) {
  //         setShowFilterOverlay(false);
  //       }
  //     };
  //     document.addEventListener("mousedown", handleClickOutside);
  //     return () => document.removeEventListener("mousedown", handleClickOutside);
  //   }, []);

  //   const uniqueValues = useMemo(() => {
  //     const dict = {
  //       status: [],
  //       priority: [],
  //       nomClient: [],
  //       title: [],
  //       users: [],
  //       dueDate: [],
  //     };

  //     archivedTodos.forEach((todo) => {
  //       if (todo.status) dict.status.push(todo.status);
  //       if (todo.priority) dict.priority.push(todo.priority);
  //       if (todo.nomClient) dict.nomClient.push(todo.nomClient);
  //       if (todo.title) dict.title.push(todo.title);
  //       if (todo.dueDate) {
  //         const formattedDate = new Date(todo.dueDate).toLocaleDateString();
  //         dict.dueDate.push(formattedDate);
  //       }
  //       if (Array.isArray(todo.users)) {
  //         todo.users.forEach((user) => {
  //           dict.users.push(`${user.name || ""} ${user.lastName || ""}`.trim());
  //         });
  //       }
  //     });

  //     Object.keys(dict).forEach((key) => {
  //       dict[key] = [...new Set(dict[key])];
  //     });

  //     return dict;
  //   }, [archivedTodos]);

  //   const handleFilterChange = (idx, field, value) => {
  //     setFilterRows((prev) =>
  //       prev.map((f, i) =>
  //         i === idx ? { ...f, [field]: value, selectedValues: [] } : f
  //       )
  //     );
  //   };

  //   const handleCheckboxValueChange = (idx, val) => {
  //     setFilterRows((prev) =>
  //       prev.map((f, i) => {
  //         if (i !== idx) return f;
  //         const sel = f.selectedValues || [];
  //         const updated = sel.includes(val)
  //           ? sel.filter((v) => v !== val)
  //           : [...sel, val];
  //         return { ...f, selectedValues: updated };
  //       })
  //     );
  //   };

  //   const handleAddFilter = () => {
  //     setFilterRows((prev) => [
  //       ...prev,
  //       { column: "status", selectedValues: [] },
  //     ]);
  //   };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUserIdsChange = (e) => {
    const ids = e.target.value.split(",").map((id) => parseInt(id.trim()));
    setFormData((prev) => ({
      ...prev,
      userIds: ids,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const todoId = editTodo.id;
    const payload = {
      ...formData,
      dueDate: formData.dueDate
        ? new Date(formData.dueDate).toISOString()
        : null,
    };

    // UI instantanée : la ligne reflète la modification et le formulaire se
    // ferme tout de suite, la sauvegarde se fait en arrière-plan
    patchTodoLocal(todoId, payload);
    setShowEditForm(false);
    setEditTodo(null);
    setFormData({
      title: "",
      status: "",
      nomClient: "",
      clientId: "",
      nature: "",
      dueDate: "",
      priority: "",
      commentaire: "",
      userIds: [],
    });

    try {
      const res = await authFetch(`https://backend-myalfa.vercel.app/api/todos/${todoId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      if (!res.ok) throw new Error("Erreur lors de la mise à jour");

      fetchTodos(); // resynchronise
    } catch (error) {
      console.error("Erreur lors de la mise à jour du todo :", error);
      fetchTodos(); // resynchronise l'état réel
      dialog.alert("La mise à jour de la tâche a échoué.");
    }
  };

  //   const handleRemoveFilter = (idx) => {
  //     setFilterRows((prev) => prev.filter((_, i) => i !== idx));
  //   };

  //   const filteredTodos = useMemo(() => {
  //     return archivedTodos.filter((todo) => {
  //       return filterRows.every((filter) => {
  //         if (!filter.selectedValues?.length) return true;

  //         if (filter.column === "users") {
  //           return todo.users?.some((user) =>
  //             filter.selectedValues.includes(
  //               `${user.name || ""} ${user.lastName || ""}`.trim()
  //             )
  //           );
  //         }

  //         if (filter.column === "dueDate") {
  //           const formatted = todo.dueDate
  //             ? new Date(todo.dueDate).toLocaleDateString()
  //             : "";
  //           return filter.selectedValues.includes(formatted);
  //         }

  //         return filter.selectedValues.includes(todo[filter.column]);
  //       });
  //     });
  //   }, [archivedTodos, filterRows]);

  const isDueDatePastOrToday = (dueDate) => {
    if (!dueDate) return false;
    const today = new Date();
    const dateToday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const due = new Date(dueDate);
    const dueOnly = new Date(due.getFullYear(), due.getMonth(), due.getDate());
    return dueOnly <= dateToday;
  };

  const isDueDateSoon = (dueDate) => {
    if (!dueDate) return false;
    const today = new Date();
    const due = new Date(dueDate);
    const diffTime = due - today;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays > 0 && diffDays <= 2;
  };

  // Ouverture instantanée : les données du todo sont déjà dans la ligne
  // cliquée, inutile de les re-télécharger depuis l'API
  const handleEditClick = (todo) => {
    setEditTodo(todo);
    setFormData({
      title: todo.title,
      status: todo.status,
      nomClient: todo.nomClient,
      clientId: todo.clientId,
      nature: todo.nature || "",
      dueDate: todo.dueDate
        ? new Date(todo.dueDate).toISOString().slice(0, 16)
        : "",
      priority: todo.priority || "",
      commentaire: todo.commentaire || "",
      userIds: (todo.users || []).map((user) => user.id),
    });
    setEditLoading(false);
    setShowEditForm(true);
  };

  const handleDeleteClick = async (e, todo) => {
    e.stopPropagation();

    const confirmDelete = await dialog.confirm(
      `Voulez-vous vraiment supprimer la tâche "${todo.title}" ?`
    );

    if (!confirmDelete) return;

    // UI instantanée : la ligne disparaît tout de suite,
    // la suppression réelle se fait en arrière-plan
    removeTodoLocal(todo.id);

    try {
      const res = await authFetch(`https://backend-myalfa.vercel.app/api/todos/${todo.id}`, {
        method: "DELETE",
      });
      if (!res.ok) throw new Error("Erreur lors de la suppression");

      fetchTodos(); // resynchronise
    } catch (error) {
      console.error("Erreur lors de la suppression du todo :", error);
      fetchTodos(); // resynchronise l'état réel (la ligne réapparaît)
      dialog.alert("Erreur lors de la suppression de la tâche.");
    }
  };

  const handleArchiveClick = async (e, todo) => {
    e.stopPropagation();

    const confirmArchive = await dialog.confirm(
      `Voulez-vous désarchiver la tâche "${todo.title}" ?`
    );
    if (!confirmArchive) return;

    // "En cours" par défaut : sans lastStatus, l'ancien code envoyait
    // status undefined et la tâche restait archivée
    const restoredStatus = todo.lastStatus || "En cours";

    // UI instantanée : la ligne quitte les archives tout de suite
    patchTodoLocal(todo.id, { status: restoredStatus });

    try {
      const res = await authFetch(`https://backend-myalfa.vercel.app/api/todos/${todo.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: restoredStatus,
        }),
      });
      if (!res.ok) throw new Error("Erreur lors du désarchivage");

      fetchTodos(); // resynchronise
    } catch (error) {
      console.error("Erreur lors du désarchivage :", error);
      fetchTodos(); // resynchronise l'état réel
      dialog.alert("Erreur lors du désarchivage.");
    }
  };

  return (
    <div>
      {/* <div style={{ marginBottom: "1rem", position: "relative" }}>
        <button
          className="BtnFilter"
          onClick={() => setShowFilterOverlay(!showFilterOverlay)}
        >
          <CiFilter size={20} /> Filtrer
        </button>
        {showFilterOverlay && (
          <div
            ref={overlayRef}
            style={{
              position: "absolute",
              top: 40,
              left: 0,
              backgroundColor: "white",
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "10px",
              zIndex: 1000,
              width: "70%",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p>Filtres avancés</p>
              <button
                onClick={() =>
                  setFilterRows([{ column: "status", selectedValues: [] }])
                }
              >
                Réinitialiser
              </button>
            </div>

            {filterRows.map((f, idx) => (
              <div key={idx} className="filtreContainer">
                <div className="filter-row">
                  <select
                    value={f.column}
                    onChange={(e) =>
                      handleFilterChange(idx, "column", e.target.value)
                    }
                  >
                    {Object.keys(uniqueValues).map((col) => {
                      const labelMap = {
                        status: "Statut",
                        priority: "Priorité",
                        nomClient: "Client",
                        title: "Tâches",
                        users: "Collaborateurs",
                        dueDate: "Échéance",
                      };
                      return (
                        <option key={col} value={col}>
                          {labelMap[col] || col}
                        </option>
                      );
                    })}
                  </select>
                  <button onClick={() => handleRemoveFilter(idx)}>
                    - Supprimer
                  </button>
                </div>
                <div className="checkboxes-list">
                  {uniqueValues[f.column]?.map((val) => (
                    <label key={val} style={{ display: "block" }}>
                      <input
                        type="checkbox"
                        checked={f.selectedValues.includes(val)}
                        onChange={() => handleCheckboxValueChange(idx, val)}
                      />
                      {val}
                    </label>
                  ))}
                </div>
              </div>
            ))}
            <button onClick={handleAddFilter}>+ Ajouter un filtre</button>
          </div>
        )}
      </div> */}

      {archivedByUser.length === 0 ? (
        <p className="text-sm text-gray-400">Aucune tâche archivée.</p>
      ) : (
        <div className="flex flex-col gap-5">
          {archivedByUser.map((userBlock) => (
            <div key={userBlock.userKey}>
              {/* Header barre bordeaux, comme la vue active */}
              <div
                onClick={() => toggleUserCollapse(userBlock.userKey)}
                className="flex items-center gap-3 cursor-pointer px-4 py-2.5 bg-[#5C1A30] rounded-xl mb-2"
              >
                <ChevronDown
                  size={14}
                  className={`text-white transition-transform duration-300 ${
                    collapsedUsers[userBlock.userKey] ? "rotate-180" : ""
                  }`}
                />
                <p className="m-0 text-white font-semibold text-xs">
                  {userBlock.name} {userBlock.lastName}
                </p>
                <div className="bg-white/20 text-white text-[10px] px-2.5 py-0.5 rounded-full font-medium">
                  {userBlock.todos.length}
                </div>
              </div>

              {!collapsedUsers[userBlock.userKey] && (
                <table className="w-full bg-white rounded-xl shadow-sm overflow-hidden">
                  <thead className="bg-[#fff6ee] w-full">
                    <tr className="border-b border-gray-100">
                      <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                        Client
                      </th>
                      <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                        Tâche
                      </th>
                      <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                        Priorité
                      </th>
                      <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                        Création
                      </th>
                      <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                        Échéance
                      </th>
                      <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                        Collaborateurs
                      </th>
                      <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                        Description
                      </th>
                      <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                        Statut d'origine
                      </th>
                      {(utilisateur.role === "ADMINISTRATEUR" ||
                        utilisateur.role === "EXPERT_COMPTABLE") && (
                        <th className="px-4 text-left py-3 text-gray-400 font-medium text-[11px]">
                          Actions
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {userBlock.todos
                      .sort(
                        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                      )
                      .map((todo) => (
                        <tr
                          key={todo.id}
                          onClick={() => setSelectedClient(todo)}
                          className={`cursor-pointer transition-all hover:bg-slate-50 ${
                            todo.status === "Terminer"
                              ? "ligne-terminee"
                              : isDueDatePastOrToday(todo.dueDate)
                              ? "ligne-en-retard"
                              : isDueDateSoon(todo.dueDate)
                              ? "ligne-bientot"
                              : ""
                          }`}
                        >
                          <td className="px-4 py-2.5 text-xs font-semibold text-gray-800">
                            {todo.nomClient}
                          </td>
                          <td className="px-4 py-2.5 text-xs text-gray-800">
                            {todo.title}
                          </td>
                          <td className="px-4 py-2.5 text-[11px] text-gray-500">
                            {todo.priority || "Non défini"}
                          </td>
                          <td className="px-4 py-2.5 text-[11px] text-gray-400">
                            {new Date(todo.createdAt).toLocaleDateString()}
                          </td>
                          <td className="px-4 py-2.5 text-[11px] text-gray-400">
                            {todo.dueDate
                              ? new Date(todo.dueDate).toLocaleDateString()
                              : "Non définie"}
                          </td>
                          <td className="px-4 py-2.5 text-xs font-semibold text-gray-600">
                            {todo.users?.length > 0
                              ? todo.users
                                  .map(
                                    (u) =>
                                      `${u.name?.[0]?.toUpperCase() || ""}${
                                        u.lastName?.[0]?.toUpperCase() || ""
                                      }`
                                  )
                                  .join("-")
                              : "Aucun"}
                          </td>
                          <td className="px-4 py-2.5 text-[11px] text-gray-500">
                            <div className="tooltip-container">
                              {todo.commentaire
                                ? todo.commentaire
                                    .split(" ")
                                    .slice(0, 3)
                                    .join(" ") +
                                  (todo.commentaire.split(" ").length > 3
                                    ? "..."
                                    : "")
                                : " "}
                              {todo.commentaire && (
                                <div className="tooltip-text">
                                  {todo.commentaire}
                                </div>
                              )}
                            </div>
                          </td>
                          <td className="px-4 py-2.5 text-[11px] text-gray-500">
                            {todo.lastStatus || "-"}
                          </td>

                          {(utilisateur.role === "ADMINISTRATEUR" ||
                            utilisateur.role === "EXPERT_COMPTABLE") && (
                            <td className="px-4 py-2.5">
                              <button
                                className="icon-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEditClick(todo);
                                }}
                                title="Modifier"
                              >
                                <FaUserEdit size={15} color="#840040" />
                              </button>
                              <button
                                className="icon-button"
                                onClick={(e) => handleDeleteClick(e, todo)}
                                style={{ marginLeft: "8px" }}
                                title="Supprimer"
                              >
                                <AiOutlineDelete size={15} color="#840040" />
                              </button>
                              <button
                                className="icon-button"
                                onClick={(e) => handleArchiveClick(e, todo)}
                                style={{ marginLeft: "8px" }}
                                title="Désarchiver"
                              >
                                <HiMiniArchiveBox size={15} color="#840040" />
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>
          ))}
        </div>
      )}

      {selectedClient &&
        (selectedClient.type === "Preparation" ? (
          <PreparationPopup
            key={selectedClient?.id}
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "Diligences" ? (
          <DiligencePopup
            key={selectedClient?.id}
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "evenement" ? (
          <EvenementPopup
            key={selectedClient?.id}
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "Verification" ? (
          <VerificationPopup
            key={selectedClient?.id}
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : selectedClient.type === "dext" ? (
          <DextPopup
            key={selectedClient?.id}
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            fetchTodos={fetchTodos}
          />
        ) : (
          <MissionPopup
            client={selectedClient}
            onClose={() => setSelectedClient(null)}
          />
        ))}
      {showEditForm && (
        <div className="overlay">
          <div className="edit-form">
            <EditTodoForm
              formData={formData}
              editLoading={editLoading}
              isSubmitting={false}
              handleFormChange={handleFormChange}
              handleUserIdsChange={handleUserIdsChange}
              handleFormSubmit={handleFormSubmit}
              onCancel={() => setShowEditForm(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Archives;
